var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChipsFilled = function SvgChipsFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C5.271 15 0 12.145 0 8.5S5.271 2 12 2s12 2.855 12 6.5S18.729 15 12 15m4 6.636a17 17 0 0 0 3-.831v-4.88a20 20 0 0 1-3 .739zm-11-.831c.91.349 1.917.629 3 .831v-4.971a20 20 0 0 1-3-.739zm9-3.887A25 25 0 0 1 12 17c-.683 0-1.349-.03-2-.082v4.988c.651.057 1.315.094 2 .094s1.349-.037 2-.094zm7-1.836v4.75c1.869-1.143 3-2.651 3-4.332v-2.513c-.794.806-1.818 1.505-3 2.096zm-18 0c-1.182-.591-2.206-1.29-3-2.096v2.513c0 1.681 1.131 3.19 3 4.332z"
  })));
};
export default SvgChipsFilled;